import React, { useState, useRef, useEffect, useContext } from "react";
import { FeatureGatingContext, useEntitlement } from "../../../contexts";
import { ShareHelper } from "../../../helpers";
import { buildListingBroadcastMessage } from "../../helpers";
import { storeCaption } from "../../../waBroadcast/waBroadcastApi";

const IEdit = () => (
  <svg width="13" height="13" viewBox="0 0 14 14" fill="none">
    <path
      d="M9.5 1.5L12.5 4.5L5 12H2V9L9.5 1.5Z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinejoin="round"
    />
  </svg>
);

const IChevron = () => (
  <svg width="12" height="12" viewBox="0 0 14 14" fill="none">
    <path
      d="M3 5l4 4 4-4"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export function LookbookActionButtons({ editButtonProps, listing, onMenuOpenChange }) {
  const { checkFeatureQuota } = useContext(FeatureGatingContext);
  // Share to Broadcast (Feature 16).
  const canShare = useEntitlement("share_to_broadcast");
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    onMenuOpenChange?.(menuOpen);
  }, [menuOpen, onMenuOpenChange]);

  useEffect(() => {
    return () => onMenuOpenChange?.(false);
  }, [onMenuOpenChange]);

  useEffect(() => {
    const handler = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) setMenuOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const onEdit = (e) => {
    e.stopPropagation();
    editButtonProps.onClick();
  };

  const onBroadcast = async (e) => {
    e.stopPropagation();
    setMenuOpen(false);
    const allowed = await checkFeatureQuota(FeatureGatingContext.features.SHARE_WHATSAPP);
    if (!allowed) return;
    // The store's own template when it has one (Owner Admin → Message templates).
    ShareHelper.whatsapp(await storeCaption("listing", listing.id, buildListingBroadcastMessage(listing)));
  };

  const menuOptions = [
    ...editButtonProps.options,
    ...(canShare ? [{ label: "Send via WhatsApp", onClick: onBroadcast }] : []),
  ];

  const onMenuOption = (option) => (e) => {
    e.stopPropagation();
    setMenuOpen(false);
    option.onClick?.(e);
  };

  return (
    <div className="lb-action-buttons" onClick={(e) => e.stopPropagation()}>
      <button type="button" className="lb-action-buttons__edit" onClick={onEdit}>
        <IEdit />
        <span>Edit</span>
      </button>

      <div className={`lb-action-buttons__menu-wrap${menuOpen ? " lb-action-buttons__menu-wrap--open" : ""}`} ref={menuRef}>
        <button
          type="button"
          className="lb-action-buttons__action"
          onClick={(e) => {
            e.stopPropagation();
            setMenuOpen((v) => !v);
          }}
          aria-expanded={menuOpen}
        >
          <span>Action</span>
          <IChevron />
        </button>

        {menuOpen && (
          <div className="lb-action-buttons__dropdown">
            {menuOptions.map((option, idx) => (
              <button
                key={idx}
                type="button"
                className={`lb-action-buttons__dropdown-item${
                  option.onClick ? "" : " lb-action-buttons__dropdown-item--muted"
                }`}
                onClick={option.onClick ? onMenuOption(option) : undefined}
                disabled={!option.onClick}
              >
                {option.label}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
